import { sleep } from "../../library-js/animation/sleep";
import { nextFrame } from "../../library-js/animation/nextFrame";
import { App } from "../../library-js/app/App";
import { HTMLEditor } from "../../library-js/dom-tools/HTMLEditor";
import { PageHandler, PageRequestEvent } from "../../library-js/dom-tools/PageHandler";
import { TemplatesList } from "../templates/TemplatesList";
import { ToggleClass } from "../../library-js/dom-actions/ToggleClass";
import { PortraitMenu } from "../../library-js/dom-actions/PortraitMenu";
import { ElementAttribute } from "../../library-js/dom-tools/ElementAttribute";
import { ImageLoader } from "../../library-js/dom-tools/ImageLoader";
import { TabSelector } from "../../library-js/dom-tools/TabSelector";
import { Radio } from "./radio/Radio";
import { ElementType } from "../../library-js/dom-tools/ElementType";
import { ClassFlag } from "../../library-js/dom-tools/ClassFlag";
import { OnClick, OnDoubleClick, OnMouseDown } from "../../library-js/dom-tools/EventListeners";
import { VotingStars } from "./votings/VotingStars";
import { VotingList } from "./votings/VotingList";
import { VotingResults } from "./votings/VotingResults";
import { JoinNewsLetterOverlay } from "./newsletter/JoinNewsLetterOverlay";
import { Fullscreen } from "../../library-js/dom-actions/Fullscreen";
import { PHPContext } from "../../library-js/php/PHPContext";
import { UnsubscribeFromNewsletter } from "./newsletter/UnsubscribeFromNewsletter";
import { RegExpUtility } from "../../library-js/text/RegExpUtility";
import { CookieInfo } from "../../library-js/php/cookie-info/CookieInfo";
import { LogView } from "../../library-js/php/logs/LogView";
import { YoutubePlayer } from "./youtube-player/YoutubePlayer";
import { DCKAlphaAccess } from "./dck-alpha-download/DCKAlphaAccess";
import { MediaGallery } from "./media-gallery/MediaGallery";
import { DCKAlphaDownload } from "./dck-alpha-download/DCKAlphaDownload";
import { RadioUI } from "./radio/RadioUI";
import { CookieDeleteAllRequest } from "../../library-js/php/cookie-info/CookieDeleteAllRequest";
import { OverlayHint, OverlayHintOptions } from "./overlay/OverlayHint";
import { LangBlock } from "./lang-block/LangBlock";
import { AttributeValue } from "../../library-js/dom-tools/AttributeValue";
import { SVGScaleStyles } from "../../library-js/dom-actions/SVGScaleStyles";
import { DCKInputSelector } from "./dck-input-type/DCKInputSelector";
import { SVGOverlay } from "../../library-js/dom/SVGOverlay";
import { VideoAutoPlayOnInsight } from "../../library-js/dom/VideoAutoPlayOnInsight";
import { ImageRotater } from "../../library-js/dom-actions/ImageRotater";
import { MediaViewer } from "../../library-js/dom-templates/MediaViewer";
import { JoinNewsLetterOverlayNew } from "./newsletter/JoinNewsLetterOverlayNew";
import { UserSignUpRequest } from "../../library-js/php/user/UserSignUpRequest";
import { SignUpOverlay as SignUpOverlay } from "./user-system/SignUpOverlay";
import { CreateAccountUI } from "./user-system/CreateAccountUI";
import { LoginUI } from "./user-system/LoginUI";
import { RokojoriUser } from "./user-system/RokojoriUser";
import { ForgotPasswordOverlay } from "./user-system/ForgotPasswordOverlay";
import { UserIcon } from "./user-system/UserIcon";
import { UserLoginStatus } from "./user-system/UserLoginStatus";
import { LogoutOverlay } from "./user-system/LogoutOverlay";
import { UserName } from "./user-system/UserName";
import { MultiString } from "../../library-js/i18n/MultiString";
import { ScrollLock } from "../../library-js/dom-actions/ScrollLock";
import { GeneralLocales } from "./i8/GeneralLocales";
import { ChangePasswordUI } from "./user-system/ChangePasswordUI";
import { ProfileUI } from "./user-system/ProfileUI";
import { UserDataValue } from "./user-system/UserDataValue";
import { RequestDeleteOverlay } from "./user-system/RequestDeleteOverlay";
import { DeleteAccountUI } from "./user-system/DeleteAccountUI";
import { JSONDiffTest } from "./_test/JSONDiffTest";
import { HTMLEditorSystem } from "../../library-js/html-editor-old/HTMLEditorSystem";
import { StoreView } from "./store/StoreView";
import { SVGKeyFrames } from "../../library-js/dom-actions/SVGKeyFrames";
import { ParallaxBlock } from "../../library-js/dom-actions/ParallaxBlock";
import { TextFX } from "../../library-js/dom-actions/text-fx/TextFX";
import { PathNavigation } from "../../library-js/dom-actions/PathNavigation";
import { ScreenSaverColors } from "../../library-js/dom-actions/ScreenSaverColors";
import { PointCounter } from "../../library-js/dom-actions/PointCounter";
import { LexCode } from "../../library-js/dom-actions/LexCode";
import { CalculatorBlock } from "../templates/apps/calculator/CalculatorBlock";
import { ScrollTo } from "../../library-js/dom-actions/ScrollTo";
import { ComputationForm } from "../../library-templates/inputs/computation--form/ComputationForm";
import { AddComputeFunctions } from "./computation-forms/AddComputeFunctions";
import { ComposerElement } from "../../library-js/audio/composer/ui/ComposerElement";
import { UIComponent } from "../../library-js/dom-ui/components/UIComponent";
import { PaypalCheckout } from "../templates/paypal-checkout/PaypalCheckout";
import { RokojoriCart } from "./cart/RokojoriCart";
import { CartItemAdder } from "../../library-js/php/cart/CartItemAdder";
import { CartEntryHandler } from "./cart/CartEntryHandler";
import { CartPrice } from "../templates/store/CartPrice";
import { AudioBuilderTest } from "../../library-js/audio/builder/test/AudioBuilderTest";
import { NodeGraph } from "../../library-templates/node-graph/model/NodeGraph";
import { NodeGraphView } from "../../library-templates/node-graph/NodeGraphView";
import { RainbowEntries } from "./rainbow-entries/RainbowEntries";
import { FilterAndSort } from "../../library-js/dom-actions/filter-and-sort/FilterAndSort";
import { CopyFill } from "../../library-js/dom-actions/copy-fill/CopyFill";
import { GradientText } from "../../library-js/dom-actions/GradientText";
import { Include } from "../../library-js/app/Include";
import { RJParserTest } from "./_test/RJParserTest";
import { RJContextMenus } from "./context-menu/RokojoriContextMenuLibrary";
import { RokojoriContextMenu } from "./context-menu/RokojoriContextMenu";
import { WaveFormTester } from "../../library-js/audio/visualization/wave-form/WaveFormTester";
import { RokojoriApps } from "./apps/rokojori/RokojoriApps";
import { CuratedItem } from "../templates/article/CuratedItem";
import { SoccerCup } from "../templates/soccer-cup/SoccerCup";
import { TimeZones } from "../templates/apps/time-zones/TimeZones";
import { AppCommandElements } from "../templates/app-commands/AppCommandElements";
import { PageEventInputData, PageEventRequest } from "../../library-js/php/page/PageEventRequest";
import { AssetManagerServer } from "./assets/AssetManagerServer";
import { CartList } from "../templates/cart/CartList";
import { AddToCartLink } from "./cart/AddToCartLink";
import { BuyNow } from "../templates/paypal-checkout/BuyNow";
import { SetCartItems } from "./cart/SetCartItems";
import { StorageTest } from "../templates/storage/StorageTest";
import { JSONViewer } from "../../library-js/editor/JSONViewer";
import { CalenderEvents } from "./calender-events/CalenderEvents";
import { CodeInfo } from "../templates/code-doc/CodeInfo";
import { DocSearch } from "../templates/code-doc/DocSearch";
import { RokojoirCookieSettings as RokojoriCookieSettings } from "./cookie-settings/RokojoriCookieSettings";
import { CookieSettings } from "../../library/ts/html/cookies/CookieSettings";
import { Cookies } from "../../library-js/php/cookie-info/Cookies";
import { EventSlot } from "../../library-js/events/EventSlot";
import { DateHelper } from "../../library-js/date/DateHelper";
import { DateMath } from "../../library-js/date/DateMath";
import { CarouselSelect } from "../templates/carousel-select/CarouselSelect";
import { DOMOrientation } from "../../library-js/dom/DOMOrientation";
import { ImageHeader } from "../templates/image-header/ImageHeader";
import { KeyManager } from "../templates/keys/manager/KeyManager";
import { OneAudioPlaying } from "../../library-templates/one--audio--playing/OneAudioPlaying";
import { UserFrontend } from "../../library/ts/html/server/user/UserFrontend";
import { MiniVideo } from "../templates/video-header/MiniVideo";
import { StreamerDB } from "../pages/_internal/streamer-db/StreamerDB";
import { StreamerDBElement } from "../pages/_internal/streamer-db/StreamerDBElement";
import { RokojoriMails } from "../pages/_internal/mails/RokojoriMails";
import { VerticalSlider } from "../../library-templates/sliders/VerticalSlider";
import { ColorGradients } from "../templates/color-gradients/ColorGradients";
import { TimeVaryingSmoothing } from "./time-varying-smoothing/TimeVaryingSmoothing";
import { CoderEditorElement } from "../templates/coder/CoderEditorElement";
import { Presentation } from "../templates/presentation/Presentation";
import { GodotShaderReference } from "../templates/godot/GodotShaderReference";
import { GodotSceneHierarchy } from "../templates/godot/godot-scene-hierarchy/GodotSceneHierarchy";
import { GodotSceneHierarchyPath } from "../templates/godot/godot-scene-hierarchy/GodotSceneHierarchyPath";
import { GodotInspector } from "../templates/godot/godot-inspector/GodotInspector";
import { GodotLinks } from "./godot-docs/GodotLinks";
import { GodotDocLinks } from "./godot-docs/GodotDocLinks";
import { VijoParty } from "../templates/vijo-party/VijoParty";
import { GDShaderStages } from "./godot/gdshader-stages/GDShaderStages";
import { UpdatePartyInvitations } from "./party/UpdatePartyInvitations";
import { TabSelectors } from "../../library-templates/tab--selectors/TabSelectors";
import { KeepInsight } from "../../library-templates/keep--insight/KeepInsight";
import { RokojoriWebsiteUserSystem } from "./user-system/UserSystem";
import { Apps } from "../templates/apps/Apps";
import { ConfirmSignup } from "./user-system/ConfirmSignup";
import { ArticleToggle } from "../templates/article/ArticleToggle";
import { VideoPlayer } from "../../library-templates/video--player/VideoPlayer";
import { ShowData } from "../js/data/ShowData";
export class Rokojori extends App
{
  private static _hide = new ClassFlag( "hide" );
  private static _naviLandscapeBar = new ElementType( "navi-landscape-bar" );
  private static _naviPortraitBar = new ElementType( "navi-portrait-bar" );
  private static _fsIcon = new ClassFlag( "fs-icon" );
  private static _pageTokenType = new ElementType( "page-token" );
  private static _pageTokenValue = new ElementAttribute( "value" );

    
  cartEntryHandler = new CartEntryHandler();

  private static _instance:Rokojori;
  private _pageToken:string;
  
  readonly assetManagerServer = new AssetManagerServer();

  get token()
  {
    if ( this._pageToken )
    {
      return this._pageToken;
    }

    let element = Rokojori._pageTokenType.queryDoc();    
    let value = Rokojori._pageTokenValue.from( element );

    if ( value === null )
    {
      return null;
    }

    this._pageToken = value.split("").reverse().join("");;

    return this._pageToken;
  }

  static locale( multi:MultiString )
  {
    return MultiString.get( multi, this._instance.pageHandler.languageCode ); 
  }

  static get $()
  {
    if ( this._instance )
    { 
      return this._instance;
    }

    this._instance = new Rokojori();

    return this._instance;
  }

  private static _context:PHPContext;

  static get phpContext() 
  {
    if ( this._context )
    {
      return this._context;
    }

    let context = new PHPContext();
    context.path  = this.$.pageHandler.getAbsolutePath( "/_php/" );
    context.token = this.$.token; 

    this._context = context;

    return this._context;
  } 

  _fullScreenToggle = new ElementAttribute( "fullscreen-toggle" );
  _rokojoriUser = new RokojoriUser();
  get _oldPHPUser(){ return this._rokojoriUser; }

  _rokojoriCart = new RokojoriCart();
  _loadingBlockWasFadedOut = false;

  constructor()
  {
    super();

    let initializerData = 
    {
      localAdress:"",
      webAdress:"https://rokojori.com",
      templatesList: TemplatesList.list,
      pageRoot: "app-stage"
    }

    let isOnline = /https\:?/.test( window.location.protocol );
    let isLocal = ! isOnline; 

    this._userSystem = new RokojoriWebsiteUserSystem( isLocal );
    this.initializeApp( initializerData );

    setTimeout(
      async ()=>
      {
        this._docLoaded.set( document.documentElement );
      },

      3000
    ); 
   

    this._oldPHPUser.initialize( this.onAnimationFrame );

    this.activityAnalyser.onActive.addListener(
      ()=>
      {
        // console.log( "On ACTIVE" );
        let naviLandscapeBar = Rokojori._naviLandscapeBar.queryDoc();

        if ( naviLandscapeBar )
        {
          Rokojori._hide.removeFrom( naviLandscapeBar );
        }

        let naviPortraitBar = Rokojori._naviPortraitBar.queryDoc();

        if ( naviPortraitBar )
        {
          Rokojori._hide.removeFrom( naviPortraitBar );
        }
        
        this.freeCursor();
      }
    );

    this.activityAnalyser.onPassive.addListener(
      ()=>
      {
        let naviLandscapeBar = Rokojori._naviLandscapeBar.queryDoc();
        
        if ( naviLandscapeBar )
        {
          Rokojori._hide.set( naviLandscapeBar );
        }

        let naviPortraitBar = Rokojori._naviPortraitBar.queryDoc();

        if ( naviPortraitBar )
        {
          Rokojori._hide.set( naviPortraitBar );
        }

        if ( DOMOrientation.isPortrait )
        {
          return;
        } 
        
        let naviHeader = new ElementType( "navi-header" ).queryDoc();

        if ( ! naviHeader || ! ClassFlag.hideable.in( naviHeader ) )
        {
          return;
        }

        console.log( "Hide Cursor" );
        this.lockCursor( "none" ); 
        
        
      }
    )

    this.pageHandler.transitionHandler = new ArcadeKickersTransitionHandler();

    

    this.sendInitialPage();

    this.addLoaderScreen();
    
    AddComputeFunctions.apply();

    this.onAnimationFrame.doOnceWhen( ()=> this.loaded, 
      async ()=>
      {
        await sleep( 500 );
        let loadingBlock = new ElementType( "loading-block" ).queryDoc() as HTMLElement;

        if ( ! loadingBlock )
        {
          this.hideLoaderScreen();
          return;
        }

        loadingBlock.style.opacity = "0";
        loadingBlock.style.pointerEvents = "none";

        this._loadingBlockWasFadedOut = true;
        
        this._docLoaded.set( document.documentElement );
        this.hideLoaderScreen();
      }
    );

    this.onAnimationFrame.addListener(
      ( e )=>
      {
        if ( ! DateMath.isNowOlderThanMS( this._lastLoadedTimeCookieSettings, 3000 ) )
        {
          return;
        }

        this.loadCookieSettings();
      }
    );
    //JSONDiffTest.test();
  }

  protected _loadingText = new ElementType<HTMLElement>( "loading-text" );
  protected _loaderScreen:HTMLElement;

  get cookieSettings()
  {
    return this._cookieSettings as RokojoriCookieSettings || ( new RokojoriCookieSettings() );
  }

  async loadCookieSettings():Promise<RokojoriCookieSettings>
  {
    this._createCookieSettings();

    this._lastLoadedTimeCookieSettings = DateHelper.now();
   
    let hasCookie = await CookieSettings.load( this._cookieSettings );

    if ( ! hasCookie )
    {
      await this.saveCookieSettings();
    }

    let stringSettings = JSON.stringify( this._cookieSettings );

    if ( this._lastLoadedCookieSettings !== stringSettings )
    {
      this._lastLoadedCookieSettings = stringSettings;

      if ( this._lastLoadedCookieSettings !== null )
      {
        this._cookieChangeListener.dispatch( this.cookieSettings );
      }
      
    }

    this._cookiesLoadingState = "Ready";

    return Promise.resolve( this._cookieSettings as RokojoriCookieSettings );
  }

  _lastSavedCookieSettings:string = null;
  _lastLoadedTimeCookieSettings = DateHelper.now();
  _lastLoadedCookieSettings:string = null;

  async changeCookieSettings( callback: ( rcs:RokojoriCookieSettings )=>void )
  {
    callback( this.cookieSettings );
    
    await this.saveCookieSettings();
    
    this._lastLoadedTimeCookieSettings = DateMath.addMilliseconds( DateHelper.now(), -10000 );

    return Promise.resolve();
  }

  protected _cookieChangeListener = new EventSlot<RokojoriCookieSettings>();
  protected _cookiesLoadingState:"Idle"|"Loading"|"Ready" = "Idle" ;

  async onCookieSettings( callback: ( rcs:RokojoriCookieSettings )=>void )
  {
    
    
    if ( "Idle" === this._cookiesLoadingState )
    {
      this._cookiesLoadingState = "Loading";
      await this.loadCookieSettings();      
    }

    while ( "Loading" === this._cookiesLoadingState )
    {
      await sleep( 1 );
    }

    callback( this.cookieSettings );

    this._cookieChangeListener.addListener( callback );    

    return Promise.resolve();
  }

  async saveCookieSettings()
  {
    let serializedSettings = JSON.stringify( this._cookieSettings );

    if ( this._lastSavedCookieSettings === serializedSettings )
    {
      //console.log( "No changes for saving:", this._lastSavedCookieSettings, serializedSettings ); 
      return Promise.resolve();
    }

    this._lastSavedCookieSettings = serializedSettings;

    //console.log( "Changes for saving:", this._lastSavedCookieSettings ); 

    await CookieSettings.save( this._cookieSettings );
  }

  protected _createCookieSettings()
  {
    if ( this._cookieSettings )
    {
      return;
    }

    CookieSettings._setContext( Rokojori.phpContext );
    this._cookieSettings = RokojoriCookieSettings.create();
  }

  sendInitialPage() 
  {
    
    setTimeout(
      async ()=>
      {
        this.pageHandler.onPageRequest.addListener(
          async ( pre )=>
          {
            let pageInput = new PageEventInputData();
            pageInput.page = pre.nextPage || "---";
            pageInput.handle = Rokojori.phpContext.token || "---";
            pageInput.data = JSON.stringify(
              { type: "changed-page",
                lastPage:pre.lastPage
              });
    
          
            
            let request = new PageEventRequest();
            await request.call( Rokojori.phpContext, pageInput, false );
                
    
          }
        )

        let pageEventInput = new PageEventInputData();

        pageEventInput.page = this.pageHandler.currentPage || "---";
        pageEventInput.handle = Rokojori.phpContext.token || "---";
        pageEventInput.data = JSON.stringify( { type: "initial-page"  });

      //console.log( "PAGE EVENT: send change", pageEventInput );

        let pageEventrequest = new PageEventRequest();
        await pageEventrequest.call( Rokojori.phpContext, pageEventInput, false );

        
      },

      1000
    )
    
    

    
  }

  addLoaderScreen()
  {   
    
    let loaderScreen = this.templatesManager.createTemplate( TemplatesList.LOADER_SCREEN, document );
    document.body.appendChild( loaderScreen );   

    this.templatesManager.processElement( loaderScreen );

    this._loaderScreen = document.querySelector( TemplatesList.LOADER_SCREEN );

    this.showLoaderScreen( { en:"Loading...", de:"Lädt..." } );
    
  }
  
  showLoaderScreen( info:MultiString = GeneralLocales.loadingLoaderInfo )
  {
    let locale = MultiString.get( info, this.pageHandler.languageCode ); 
    HTMLEditor.setText( this._loadingText.query( this._loaderScreen ), locale );
    ClassFlag.active.set( this._loaderScreen );  
    ScrollLock.enable();
  }

  hideLoaderScreen()
  {
    ClassFlag.active.removeFrom( this._loaderScreen );
    ScrollLock.disable();
  }

  _docLoaded = new ClassFlag( "document-loaded" );
  protected _userSystem:RokojoriWebsiteUserSystem;

  get userSystem()
  {
    return this._userSystem;
  }

  // _userFrontend = new UserFrontend();

  // get user()
  // {
  //   return this._userFrontend;
  // }

  async initializePage()
  {
    await super.initializePage();


    this._cookieChangeListener.removeAll();

    StreamerDBElement.applyOnDocument();

   

    Include.all( this );
    RokojoriApps.applyOnDocument( this );
    MiniVideo.applyOnDocument( this.pageHandler );

    try
    {
      await this._userSystem.applyOnDocument();
      Apps.applyOnDocument();
    }
    catch( e )
    {
      console.log( e );
    }



    // this._userFrontend._phpContext = Rokojori.phpContext;
    // await this._userFrontend.applyOnDocument();

    // KeyManager.applyOnDocument( this._userFrontend );

    CarouselSelect.applyOnDocument();
    ImageHeader.applyOnDocument();
    
    ToggleClass.applyOnDocument();
    PortraitMenu.applyOnDocument();
    ImageLoader.applyOnDocument( TemplatesList.INPUT_IMAGE );
    TabSelector.applyOnDocument();

    OneAudioPlaying.applyOnDocument();

    
    ImageRotater.applyOnDocument( this.onAnimationFrame, this.inputManager );
      
    CoderEditorElement.applyOnDocument();
    /*
    JoinNewsLetterOverlayNew.applyOnDocument();
    UnsubscribeFromNewsletter.applyOnDocument();
    */
    RJParserTest.applyOnDocument();
    
    
    
    
    SignUpOverlay.applyOnDocument();
    ConfirmSignup.applyOnDocument();
    CreateAccountUI.applyOnDocument();
    LoginUI.applyOnDocument();
    UserIcon.applyOnDocument();
    ForgotPasswordOverlay.applyOnDocument();
    UserLoginStatus.applyOnDocument();
    LogoutOverlay.applyOnDocument();
    ChangePasswordUI.applyOnDocument();
    UserName.applyOnDocument();
    ProfileUI.applyOnDocument();
    UserDataValue.applyOnDocument();
    RequestDeleteOverlay.applyOnDocument();
    DeleteAccountUI.applyOnDocument();



    RokojoriContextMenu.applyOnDocument( this.onAnimationFrame, this.inputManager );
    
    YoutubePlayer.applyOnDocument();

    MediaGallery.applyOnDocument();
    VideoPlayer.applyOnDocument();
    RadioUI.applyOnDocument();
    SVGScaleStyles.applyOnDocument();

    SVGOverlay.applyOnDocument( this.onAnimationFrame, this.landscapeScale );
    VideoAutoPlayOnInsight.applyOnDocument( this.insight );
    MediaViewer.applyOnDocument( this.templatesManager );
    StoreView.applyOnDocument();
    ParallaxBlock.applyOnDocument( this.onAnimationFrame );
    TextFX.applyOnDocument( this.insight );
    PathNavigation.applyOnDocument();
    ComposerElement.applyOnDocument( this.onAnimationFrame );
    RokojoriMails.applyOnDocument();
    VerticalSlider.applyOnDocument( 
      ()=>{ this.lockCursor( "ew-resize"); }, 
      ()=> { this.freeCursor() }
    );

    SVGKeyFrames.applyOnDocument();
    ScreenSaverColors.applyOnDocument( this.onAnimationFrame );
    PointCounter.applyOnDocument();
    LexCode.applyOnDocument();
    ScrollTo.applyOnDocument();
    FilterAndSort.applyOnDocument();

    CuratedItem.applyOnDocument();

    CopyFill.applyOnDocument();

    WaveFormTester.applyOnDocument();

    ArticleToggle.applyOnDocument();
    
    TimeZones.applyOnDocument( this.onAnimationFrame );

    CodeInfo.applyOnDocument();
    DocSearch.applyOnDocument();
    
    TimeVaryingSmoothing.applyOnDocument();

    CartList.applyOnDocument( this.assetManagerServer.assetsCart, this.templatesManager );
    CartItemAdder.applyOnDocument( this.assetManagerServer.assetsCart );
    CartPrice.applyOnDocument();
    SetCartItems.applyOnDocument();

    StorageTest.applyOnDocument();
    JSONViewer.applyOnDocument();

    AddToCartLink.applyOnDocument();

    PaypalCheckout.applyOnDocument();
    BuyNow.applyOnDocument( this.onAnimationFrame, this.templatesManager );

    CalculatorBlock.applyOnDocument();
    
    AudioBuilderTest.applyOnDocument();

    ComputationForm.applyOnDocument();

    NodeGraphView.applyOnDocument();

    RainbowEntries.applyOnDocument( this.onAnimationFrame );

    // ConnectorTest.applyOnDocument();

    GradientText.applyOnDocument();

    AppCommandElements.applyOnDocument();
    Presentation.applyOnDocument( this.inputManager, this.onAnimationFrame );

    GodotShaderReference.applyOnDocument();
    GodotSceneHierarchy.applyOnDocument();
    GodotSceneHierarchyPath.applyOnDocument();
    GodotInspector.applyOnDocument();    
    GodotLinks.applyOnDocument();


    CookieDeleteAllRequest.applyOnDocument( 
      Rokojori.phpContext, async ()=>
    {
      
      let title = LangBlock.createHTML(
        {
          en: "Info"
        }
      );

      let info = LangBlock.createHTML(
        {
          en: "All cookies have been deleted.",
          de: "Alle cookies wurden gelöscht."
        }
      ) 

      let options = new OverlayHintOptions();
      options.isCancable = false;
      await OverlayHint.hint( title, info, options );

      CookieInfo.status = undefined;

      // this.setCookieInfo();
    } 
    );
  
    
    LogView.applyOnDocument();
    //HTMLEditorSystem.applyOnDocument( this );

    //this.setCookieInfo();

    ColorGradients.applyOnDocument( this.onAnimationFrame );
    VijoParty.applyOnDocument( this.onAnimationFrame );
    GDShaderStages.applyOnDocument();
    UpdatePartyInvitations.applyOnDocument();

    TabSelectors.applyOnDocument();
    KeepInsight.applyOnDocument( this.onAnimationFrame );

    ShowData.applyOnDocument();
    // UserSystemTester.applyOnDocument();

    //APICall.applyListener( JoinMailingList );
    //APICall.applyListener( Unsubscribe );

    let fsIcon = Rokojori._fsIcon.queryDoc() as HTMLElement;

    if ( fsIcon )
    {
      OnMouseDown.add( Rokojori._fsIcon.queryDoc() as HTMLElement, ()=>{ this.toggleFullScreen() } );
    }    

    this._fullScreenToggle.forEachInDoc(
      ( fs )=>
      {
        OnClick.add( fs as HTMLElement, ()=>{ this.toggleFullScreen(); });
      }
    )


    Radio.applyOnDocument();

    CalenderEvents.applyOnDocument();

    GodotDocLinks.applyOnDocument()
        
  }

  toggleFullScreen()
  {
    Fullscreen.toggle( document.documentElement );
  }

  setCookieInfo()
  {
    let showInfo = () => 
    {
      let cookieInfo = this.templatesManager.createTemplate( TemplatesList.COOKIE_INFO, document ) as HTMLElement;
      this.pageHandler.resolveRootPaths( cookieInfo );
      let pageRoot = document.querySelector( this.pageHandler.pageRootTag );
      pageRoot.appendChild( cookieInfo )
      
      let lang = this.pageHandler.currentLanguage;
      let rootAttribute = new ElementAttribute( "lang" );
      let rootValue = new AttributeValue( rootAttribute, lang );
      let root = rootValue.query( cookieInfo );

      console.log( "COOKIE INFO", rootValue.selector, ">>", root, cookieInfo.outerHTML,  );
      let button = ElementType.button.query( root );

      setTimeout(
        ()=>
        {
          HTMLEditor.setClass( cookieInfo, "visible", true ); 
        },
        300
      )
    
      return button;
    }    

    let hideInfo:()=>void = () => 
    { 
      let cookieInfo = document.querySelector( TemplatesList.COOKIE_INFO );
      HTMLEditor.setClass( cookieInfo, "visible", false ); 
    }

    if ( ! PageHandler.isHiddenPage() )
    {
      CookieInfo.applyOnDocument( Rokojori.phpContext, showInfo, hideInfo );
    }
    


     /*let naviHeader = ElementType.queryDoc( TemplatesList.NAVI_HEADER );

     if ( naviHeader )
    {
      OnDoubleClick.add( naviHeader as HTMLElement, ()=>{ this.toggleFullScreen() } );
    }
    
    */
    
  }

  _cursorLayer:HTMLElement;

  lockCursor( type:string )
  {
    if ( this._cursorLayer )
    {
      this.freeCursor();
    }

    let cursorOverlay = this.templatesManager.createTemplate( TemplatesList.CURSOR_OVERLAY, document ) as HTMLElement;

    var target = document.fullscreenElement || document.body;
    target.appendChild( cursorOverlay );   
    cursorOverlay.style.cursor = type;

    this.templatesManager.processElement( cursorOverlay );

    this._cursorLayer = document.querySelector( TemplatesList.CURSOR_OVERLAY );

  }

  freeCursor()
  {
    HTMLEditor.remove( this._cursorLayer );
    this._cursorLayer = null;
  }

  
}

export class ArcadeKickersTransitionHandler
{
  visibleAttribute = new ElementAttribute( "blending-visible" );
  private _stageBlend:Element = null;

  get stageBlend()
  {
    return this._stageBlend;
  }

  ensureStageBlend()
  {
    if ( this._stageBlend )
    {
      return;
    }

    let rj = Rokojori.$;
   
    let stageBlend = rj.templatesManager.createTemplate( TemplatesList.STAGE_BLEND, document );
    document.body.appendChild( stageBlend );   

    rj.templatesManager.processElement( stageBlend );

    this._stageBlend = document.querySelector( TemplatesList.STAGE_BLEND )
    

    return;
  }


  async onTransitionOut( pageHandler:PageHandler ):Promise<void>
  {
    this.ensureStageBlend();

    await nextFrame();

    this.visibleAttribute.to( this.stageBlend, "true" );

    await sleep( 300 );

    return Promise.resolve();
  }

  async onTransitionIn( pageHandler:PageHandler ):Promise<void>
  {
    
    Rokojori.$.initializePage();

    this.visibleAttribute.to( this.stageBlend, "false" );

  }

  

}
